import { Route, Routes } from "react-router-dom";
import CodTransferCreateScreen from "screens/App/CRM/Payment/CodTransfer/CodTransferCreateScreen";
import CodTransferDetailScreen from "screens/App/CRM/Payment/CodTransfer/CodTransferDetailScreen";
import CodTransferEditScreen from "screens/App/CRM/Payment/CodTransfer/CodTransferEditScreen";
import CodTransferListScreen from "screens/App/CRM/Payment/CodTransfer/CodTransferListScreen";
import CODChargeDeductReportDetailView from "screens/App/CRM/Reports/PaymentReports/VendorReports/CODChargeDeductReportDetailView";

import { NotFoundScreen } from "screens/NotFoundScreen";

const CodTransferRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<CodTransferCreateScreen />} />
      <Route path=":id/detail" element={<CodTransferDetailScreen />} />
      <Route path="list" element={<CodTransferListScreen />} />
      <Route path=":id/edit" element={<CodTransferEditScreen />} />
      <Route path=":id/detail-view" element={<CODChargeDeductReportDetailView />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default CodTransferRouter;
